// The line-down status line for a reader whose role cannot open Maintenance
// (F16 UF-01): the red pill above it stays, as text, and this says who acts.
export function LineDownStatus() {
  return (
    <p className="px-1 text-sm text-fg-muted">A supervisor resumes it in Maintenance.</p>
  )
}
